import { render, staticRenderFns } from "./GraphDetail19.vue?vue&type=template&id=22441321&scoped=true"
import script from "./GraphDetail19.vue?vue&type=script&lang=js"
export * from "./GraphDetail19.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22441321",
  null
  
)

export default component.exports